export type ApiHttpMethod = "GET" | "POST" | "PATCH" | "DELETE";
export type ApiContractConfidence = "catalog-source-backed" | "catalog-needs-annotation" | "source-provisional";
export type ApiAuthMode = "public" | "platform-session" | "internal-service-key" | "same-origin-proxy";
export type ApiIdempotencyPolicy = "required" | "optional" | "forbidden";
export type ApiSideEffectPolicy = "none" | "db1-write" | "readiness-evidence" | "provider-closed";

export type ApiPathValue = string | number | boolean | null | undefined;

export interface ApiSourceRef {
  label: string;
  path: string;
  line?: number;
}

export type ApiLane = "coaching-product" | "platform-auth";

export interface ApiEndpointContract {
  key: string;
  family: string;
  method: ApiHttpMethod;
  pathTemplate: string;
  /** Which deployed lane serves the route. Defaults to the coaching product API when omitted. */
  lane?: ApiLane;
  authMode: ApiAuthMode;
  idempotency: ApiIdempotencyPolicy;
  confidence: ApiContractConfidence;
  catalogStableKey?: string;
  sourceRefs: ApiSourceRef[];
  sideEffects: ApiSideEffectPolicy[];
  roleScopeNotes: string[];
  notes: string;
}

export interface ApiContractBlocker {
  key: string;
  family: string;
  requirement: string;
  status: "missing-backend-route" | "missing-catalog-annotation" | "needs-product-decision";
  notes: string;
}

export function buildApiPath(
  template: string,
  pathParams: Record<string, ApiPathValue> = {},
  query: Record<string, ApiPathValue> = {}
) {
  let path = template;

  for (const [key, value] of Object.entries(pathParams)) {
    if (value === null || value === undefined || value === "") {
      throw new Error(`Missing API path parameter: ${key}`);
    }
    path = path.replaceAll(`:${key}`, encodeURIComponent(String(value)));
  }

  if (path.includes(":")) {
    throw new Error(`Unresolved API path parameter in ${path}`);
  }

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === null || value === undefined || value === "") continue;
    searchParams.set(key, String(value));
  }

  const queryString = searchParams.toString();
  return queryString ? `${path}?${queryString}` : path;
}

export function assertIdempotency(contract: ApiEndpointContract, idempotencyKey?: string) {
  if (contract.idempotency === "required" && !idempotencyKey) {
    throw new Error(`${contract.key} requires an Idempotency-Key`);
  }
}
